import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input/Input';

import AccountSelection from '../../containers/shared_policies/AccountSelection';
import ThreatPolicy from '../../containers/shared_policies/ThreatPolicy';

const AddPolicy = ({ classes, display, fields, updateSetting }) => (
  <Grid id="add-advance-policy" container spacing={0}>
    <Grid item xs={12} className={classes.levelContainer}>
      <div className={classes.header}>Shared Policy Name</div>
      <Input
        placeholder="Provide a name to keep track of this policy"
        className={classes.input_wrapper}
        onChange={e => {
          updateSetting('name', e.target.value);
        }}
        disabled={false}
        disableUnderline={true}
        value={fields.name}
      />
      <div className={classes.header}>Linked Accounts</div>
      <AccountSelection disabled={false} />
    </Grid>
    <Grid item xs={12} className={classes.addContainer}>
      <ThreatPolicy customExclusion="ALL" />
    </Grid>
  </Grid>
);

AddPolicy.propTypes = {
  classes: PropTypes.object.isRequired,
  display: PropTypes.string.isRequired,
  disabledAD: PropTypes.bool,
};

AddPolicy.defaultProps = {};

const styles = {
  addContainer: {},
  header: {
    color: 'rgb(0,0,0,0.9)',
    fontFamily: 'Roboto',
    fontSize: '14px',
    letterSpacing: 0,
    lineHeight: '24px',
  },
  input_wrapper: {
    marginLeft: 0,
    marginRight: 25,
    width: '100%',
    fontSize: 14,
    border: '1px solid #B2B2B2',
    paddingLeft: '10px',
    borderRadius: '2px',
    background: '#FFFFFF',
    height: '32px !important',
    boxShadow: 'inset 0 1px 2px 0 rgba(0,0,0,0.2)',
    marginBottom: '10px',
  },
  levelContainer: {
    padding: '24px 24px 16px 24px',
    backgroundColor: '#F7F7F7',
    borderBottom: '1px solid #DDDDDD',
  },
};

export default withStyles(styles, { name: 'AddPolicy' })(AddPolicy);
